import React, { useState, useEffect } from "react";
import "../static/css/AdminTeam.css";

function AdminTeam() {
  const [name, setName] = useState("");
  const [role, setrole] = useState("");
  const [short_description, setshort_description] = useState("");
  const [description, setdescription] = useState("");
  const [image, setImage] = useState(null);
  const [specializations, setSpecializations] = useState([""]);
  const [credentials, setCredentials] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [linkedin_url, setLinkedinUrl] = useState("");

  const addSpecialization = () => {
    setSpecializations([...specializations, ""]);
  };

  const handleSpecializationChange = (index, value) => {
    const updatedSpecializations = [...specializations];
    updatedSpecializations[index] = value;
    setSpecializations(updatedSpecializations);
  };

  const [teamMembers, setTeamMembers] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [editId, setEditId] = useState(null);

  useEffect(() => {
    fetchTeamMembers();
  }, []);

  const fetchTeamMembers = async () => {
    try {
      const response = await fetch("http://backend.ibcupdates.com//team");
      const data = await response.json();
      setTeamMembers(data);
    } catch (error) {
      console.error("Error fetching team members:", error);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this team member?")) {
      try {
        const response = await fetch(`http://backend.ibcupdates.com//team/delete/${id}`, {
          method: "DELETE",
        });
        if (response.ok) {
          alert("Team member deleted successfully");
          fetchTeamMembers();
        } else {
          alert("Failed to delete team member");
        }
      } catch (error) {
        console.error("Error deleting team member:", error);
      }
    }
  };

  const resetForm = () => {
    setName("");
    setrole("");
    setshort_description("");
    setdescription("");
    setImage(null);
    setSpecializations([""]);
    setCredentials("");
    setEmail("");
    setPhone("");
    setLinkedinUrl("");
    setIsEditing(false);
    setEditId(null);
  };

  const handleEdit = (member) => {
    setIsEditing(true);
    setEditId(member.id);
    setName(member.name);
    setrole(member.role);
    setshort_description(member.short_description);
    setdescription(member.description);
    setCredentials(member.credentials || "");
    setEmail(member.email || "");
    setPhone(member.phone || "");
    setLinkedinUrl(member.linkedin_url || "");
    // Note: specializations might be JSON string or array depending on API
    if (member.specializations) {
        try {
            const specs = typeof member.specializations === 'string' ? JSON.parse(member.specializations) : member.specializations;
            setSpecializations(Array.isArray(specs) ? specs : [specs]);
        } catch (e) {
            setSpecializations([member.specializations]);
        }
    } else {
        setSpecializations([""]);
    }
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("name", name);
    formData.append("role", role);
    formData.append("short_description", short_description);
    formData.append("description", description);
    formData.append("credentials", credentials);
    formData.append("email", email);
    formData.append("phone", phone);
    formData.append("linkedin_url", linkedin_url);
    if (image) {
        formData.append("image", image);
    }
    formData.append("specializations", JSON.stringify(specializations));

    const url = isEditing 
        ? `http://backend.ibcupdates.com//team/update/${editId}`
        : "http://backend.ibcupdates.com//team/add";
    
    const method = isEditing ? "PUT" : "POST";

    try {
      const response = await fetch(url, {
        method: method,
        body: formData,
      });

      if (response.ok) {
        alert(`Team member ${isEditing ? "updated" : "added"} successfully!`);
        fetchTeamMembers(); // Refresh the list
        resetForm();
      } else {
        const errorText = await response.text();
        console.error("Error response:", errorText);
        alert(`Failed to ${isEditing ? "update" : "add"} team member: ` + errorText);
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Error submitting form.");
    }
  };

  return (
    <>
      <div className="team-page">
        <div className="admin-team" style={{ flexDirection: "column" }}>
          <div className="admin-team__container">
            <h3>Add New Team Member</h3>
            <form className="admin-team__form" onSubmit={handleSubmit}>
              <div className="admin-team__form-group">
                <label htmlFor="name">Team Member Name</label>
                <input
                  id="name"
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  className="admin-team__input"
                />
              </div>

              <div className="admin-team__form-group">
                <label htmlFor="role">Role</label>
                <input
                  id="role"
                  type="text"
                  value={role}
                  onChange={(e) => setrole(e.target.value)}
                  className="admin-team__input"
                />
              </div>

              <div className="admin-team__form-group">
                <label htmlFor="short_description">Short Description</label>
                <textarea
                  id="short_description"
                  value={short_description}
                  onChange={(e) => setshort_description(e.target.value)}
                  className="admin-team__input"
                  rows="3"
                  placeholder="Brief summary or tagline"
                />
              </div>

              <div className="admin-team__form-group">
                <label htmlFor="description">description</label>
                <textarea
                  id="description"
                  value={description}
                  onChange={(e) => setdescription(e.target.value)}
                  className="admin-team__input"
                  rows="5"
                  placeholder="Detailed description or biography"
                />
              </div>

              <div className="admin-team__form-group">
                <label htmlFor="credentials">Key Professional Credentials</label>
                <textarea
                  id="credentials"
                  value={credentials}
                  onChange={(e) => setCredentials(e.target.value)}
                  className="admin-team__input"
                  rows="4"
                  placeholder="e.g., Fellow Chartered Accountant (FCA), Certified Forensic Auditor (FAFD), etc."
                />
              </div>

              <div className="admin-team__form-group">
                <label htmlFor="email">Email</label>
                <input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="admin-team__input"
                />
              </div>

              <div className="admin-team__form-group">
                <label htmlFor="phone">Phone</label>
                <input
                  id="phone"
                  type="tel"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  className="admin-team__input"
                />
              </div>

              <div className="admin-team__form-group">
                <label htmlFor="linkedin_url">LinkedIn Profile URL</label>
                <input
                  id="linkedin_url"
                  type="url"
                  value={linkedin_url}
                  onChange={(e) => setLinkedinUrl(e.target.value)}
                  className="admin-team__input"
                />
              </div>

              <div className="admin-team__form-group">
                <label>Specialization</label>
                {specializations.map((specialization, index) => (
                  <input
                    key={index}
                    type="text"
                    value={specialization}
                    onChange={(e) =>
                      handleSpecializationChange(index, e.target.value)
                    }
                    placeholder={`Specialization ${index + 1}`}
                    className="admin-team__input"
                  />
                ))}
                <button
                  type="button"
                  onClick={addSpecialization}
                  className="admin-team__add-btn"
                >
                  Add Another Specialization
                </button>
              </div>

              <div className="admin-team__form-group">
                <label htmlFor="TeamMember">Team Member Image</label>
                <div className="admin-team__file-upload">
                  <input
                    type="file"
                    id="thumbnail"
                    onChange={(e) => setImage(e.target.files[0])}
                    className="admin-team__file-input"
                  />
                  <span className="admin-team__upload-placeholder">
                    <i
                      className="admin-team__upload-icon"
                      id="image"
                      value={image}
                    >
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M2.66667 24C1.93333 24 1.30556 23.7389 0.783333 23.2167C0.261111 22.6944 0 22.0667 0 21.3333V2.66667C0 1.93333 0.261111 1.30556 0.783333 0.783333C1.30556 0.261111 1.93333 0 2.66667 0H21.3333C22.0667 0 22.6944 0.261111 23.2167 0.783333C23.7389 1.30556 24 1.93333 24 2.66667V21.3333C24 22.0667 23.7389 22.6944 23.2167 23.2167C22.6944 23.7389 22.0667 24 21.3333 24H2.66667ZM2.66667 21.3333H21.3333V2.66667H2.66667V21.3333ZM4 18.6667H20L15 12L11 17.3333L8 13.3333L4 18.6667Z"
                          fill="#828282"
                        />
                      </svg>
                    </i>
                    Upload Image
                  </span>
                </div>
              </div>
              <button type="submit" className="admin-team__submit-btn">
                {isEditing ? "Update Member" : "Add Member"}
              </button>
              {isEditing && (
                <button 
                  type="button" 
                  className="admin-team__submit-btn" 
                  onClick={resetForm}
                  style={{ backgroundColor: "#888", marginTop: "10px" }}
                >
                  Cancel Edit
                </button>
              )}
            </form>
          </div>

          <div className="admin-team__list" style={{ marginTop: "30px", width: "100%", maxWidth: "800px" }}>
            <h3>Existing Team Members</h3>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))", gap: "20px" }}>
              {teamMembers.map((member) => (
                <div key={member.id} style={{ background: "white", padding: "15px", borderRadius: "8px", boxShadow: "0 2px 5px rgba(0,0,0,0.1)", textAlign: "center", position: "relative" }}>
                   <img
                    src={`http://backend.ibcupdates.com/${member.image.replace(/\\/g, "/")}`}
                    alt={member.name}
                    style={{ width: "100px", height: "100px", borderRadius: "50%", objectFit: "cover", marginBottom: "10px" }}
                  />
                  <h4 style={{ margin: "5px 0" }}>{member.name}</h4>
                  <p style={{ fontSize: "12px", color: "#666" }}>{member.role}</p>
                  <div className="item-actions">
                    <button 
                      className="edit-btn"
                      onClick={() => handleEdit(member)}
                    >
                      Edit
                    </button>
                    <button 
                      className="delete-btn"
                      onClick={() => handleDelete(member.id)}
                    >
                      Delete
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default AdminTeam;
